import en from './en.json';

export default {
  'en-GB': {
    ...en,
  },
};
